import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Container} from "react-bootstrap";

export default function Footer() {
	return (
		<>
			<Container className="mt-5">
				<hr/>
				<Row>
					<Col md={6} sm={12}>
						<Container>
							<p>
								<strong>Sociální pracovník v mobilu</strong>
							</p>
							<hr/>
							<address>
								<p>Adéla Michková (odborný garant)</p>
								<p>
									email:{' '}
									<a href="mailto:adela@socpracvmobilu.cz">
										adela@socpracvmobilu.cz
									</a>
								</p>
								<p>mobil: +420 727 941 707</p>
							</address>
						</Container>
					</Col>
					<Col md={6} sm={12}>
						<Container>
							<p>
								&nbsp;
							</p>
							<hr/>
							<address>
								<p>Karel Zavadil (vývoj aplikace)</p>
								<p>
									email: <a href="mailto:karel@zavadil.eu">karel@zavadil.eu</a>
								</p>
							</address>
						</Container>
					</Col>
				</Row>
			</Container>
			<Container className="text-center">
				<br/>
				<hr/>
				<br/>
				<p>
					<strong>Projekt realizuje</strong>
				</p>
				<div style={{marginBottom: '10px'}}>
					<img
						height="100"
						src="logo-upc-fzs.png"
						alt="Univerzita Pardubice, Fakulta zdravotnických studií"
					/>
				</div>
				<p>
					<strong>Projekt vznikl za podpory</strong>
				</p>
				<div style={{paddingTop: '10px'}}>
					<Row>
						<Col>
							<img
								height="50"
								src="logo-nadace.svg"
								alt="Nadace Vodafone Česká republika"
							/>
						</Col>
						<div className="d-xs-block d-sm-none">
							<br/>
							<br/>
							<br/>
						</div>
						<Col>
							<img
								height="60"
								src="logo-eu-esf.png"
								alt="EU Operační program Zaměstnanost."
							/>
						</Col>
					</Row>
				</div>
			</Container>
		</>
	);
}
